import * as React from "react";
const SvgChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 14L12.3536 10.3536C12.1583 10.1583 11.8417 10.1583 11.6464 10.3536L8 14", stroke: "#737373", style: {
  stroke: "#737373",
  stroke: "color(display-p3 0.4500 0.4500 0.4500)",
  strokeOpacity: 1
}, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronUp;
